/**
 * Use <password-reveal label-show="Show" label-hide="Hide"> as a wrapper for <input type="password">
 *
 * Accepted attributes:
 *  - `reveal` {boolean} Whether to reveal or hide the password
 *  - `label-show` {string} Display specific label to show password
 *  - `label-hide` {string} Display specific label to hide password
 *  - `icon-show` {string} URL to icon for show password
 *  - `icon-hide` {string} URL to icon for hide password
 */
if (!customElements.get("password-reveal")) {
  class PasswordReveal extends HTMLElement {
    constructor() {
      super();

      this.$input = this.querySelector('input[type="password"]');
      if (!this.$input)
        throw new Error('Missing nested <input type="password"> element');

      // Display password element
      this.$pwd = document.createElement("div");
      this.$pwd.classList.add("reveal-password");
      this.$pwd.style.display = "none";
      this.$pwd.style.pointerEvents = "none";
      this.$pwd.style.userSelect = "none";
      this.$input.after(this.$pwd);

      // Toggle password element
      this.$toggle = document.createElement("button");
      this.$toggle.type = "button";
      this.$toggle.addEventListener("click", (event) => {
        event.preventDefault();
        this.toggle();
      });
      this.$input.after(this.$toggle);

      this.$input.addEventListener("input", () => {
        if (this.shouldReveal()) {
          this.$pwd.innerText = this.$input.value;
        }
      });

      if (this.shouldReveal()) {
        this.show();
      } else {
        this.hide();
      }
    }

    shouldReveal() {
      const reveal = this.getAttribute("reveal");
      return reveal === "true" || reveal === true;
    }

    show() {
      this.$pwd.innerText = this.$input.value;
      this.$toggle.innerText =
        this.getAttribute("label-hide") || "Hide password";
      this.$toggle.style.backgroundImage = this.getAttribute("icon-hide")
        ? `url(${this.getAttribute("icon-hide")})`
        : undefined;
      this.$pwd.style.display = "block";
      this.setAttribute("reveal", true);
    }

    hide() {
      this.$pwd.innerText = "";
      this.$toggle.innerText =
        this.getAttribute("label-show") || "Show password";
      this.$toggle.style.backgroundImage = this.getAttribute("icon-show")
        ? `url(${this.getAttribute("icon-show")})`
        : undefined;
      this.$pwd.style.display = "none";
      this.removeAttribute("reveal");
    }

    toggle(reveal) {
      const _reveal =
        reveal !== undefined ? reveal : this.getAttribute("reveal");
      if (_reveal) {
        this.hide();
      } else {
        this.show();
      }
    }
  }

  customElements.define("password-reveal", PasswordReveal);
}
